import { TileRoleRoute } from '@/types'
import { faCaravan } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'

export const EstSoftwareRoute: TileRoleRoute = {
  path: 'estsoftware',
  text: 'Software Est.',
  faIcon: faCaravan,
  element: (
    <ManagementGridFactory
      entity="est_software"
      referencesCollection={'licenze_est'}
      referencesTitle="Software Est."
      displayField="id"
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Software Est.',
      icon: faCaravan,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
